import StorageHelper from '@/utils/storageHelper';
import { ensureClientIdPosted } from '@/utils/clientIdUtils';
import { clearAppData } from '@/mixins/storageUtils.js';
import RoutesRoot from '@/router/routes/RoutesRoot.js';
import RoutesLogin from '@/router/routes/authentication/RoutesLogin.js';
import RoutesAthentication from '@/router/routes/RoutesAthentication.js';
import cache from '@/services/Api/cache';
import { getOrCreateClientSessionId } from './clientSessionIdUtils';

export async function handleCacheClear() {
  const clientId = await ensureClientIdPosted();
  const clientSessionId = getOrCreateClientSessionId();

  const clientIdPostedFlagStorage = new StorageHelper({
    id: process.env.VUE_APP_STORAGE_PMAKTIF_CLIENT_ID_POSTED_FLAG,
  });
  const isClientIdPosted = clientIdPostedFlagStorage?.get() === true;

  cache
    .getCacheClear()
    .then(res => {
      if (!res) return;
      const { shouldClear } = res?.data?.Data;

      if (shouldClear) {
        cache
          .putCacheClear()
          .then(res => {
            if (!res) return;
            if (!res?.data?.Data?.completed) return;

            localStorage.clear();
            // rewrite clientId and clientIdPostedFlag into localStorage
            new StorageHelper({
              id: process.env.VUE_APP_STORAGE_PMAKTIF_CLIENT_ID,
            }).set(clientId);
            new StorageHelper({
              id: process.env.VUE_APP_STORAGE_PMAKTIF_CLIENT_SESSION_ID,
            }).set(clientSessionId);
            clientIdPostedFlagStorage.set(isClientIdPosted);

            clearAppData(
              'logout',
              `${RoutesRoot.Authentication.path}/${RoutesAthentication.Login.path}/${RoutesLogin.SelectLoginType.path}`,
            );
          })
          .catch(error => {
            console.error('putCacheClear error:', error);
          });
      }
    })
    .catch(error => {
      console.error('getCacheClear error:', error);
    });
}
